import { useEffect } from "react";
import { createPortal } from "react-dom";

function GalleryLightbox({ item, alt, onClose, closeLabel }) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  function handleBackdropClick(event) {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }

  return createPortal(
    <div
      className="gallery-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onClick={handleBackdropClick}
    >
      <button
        type="button"
        className="gallery-lightbox-close"
        onClick={onClose}
        aria-label={closeLabel}
      >
        ×
      </button>

      <figure className="gallery-lightbox-figure">
        {item.type === "video" ? (
          <video
            src={item.video}
            poster={item.poster}
            className="gallery-lightbox-image"
            controls
            autoPlay
            muted
            loop
            playsInline
            aria-label={alt}
          />
        ) : (
          <img src={item.image} alt={alt} className="gallery-lightbox-image" />
        )}
      </figure>
    </div>,
    document.body,
  );
}

export default GalleryLightbox;
